import { h } from 'preact';
import * as BaseComp from 'components/bolt/homeEnt/homeEnt.js';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/homeEnt/homeEnt.sss';

export default class HomeEnt extends BaseComp.default {
	render(props) {
		const base = super.render(props);
		const isDesktopSize = props?.store?.client?.isDesktopSize;
		const hasUarHeader = props?.store?.appData?.header?.uarHeader;

		if (hasUarHeader) {
			const homeEntContainer = findInVNode(base, `.${s.container}`);
			if (homeEntContainer) {
				homeEntContainer.attributes.style = {
					...homeEntContainer.attributes.style,
					top: isDesktopSize ? '80px' : '128px'
				};
			}
		}
		return base;
	}

}
